import Handlebars from 'handlebars';
import toastr from 'toastr';
import Settings from '~/settings.js';

import EventHub from '~/eventHub';
import admincategories_template from '~/templates/adminCategories.handlebars';
import collaborators_template from '~/templates/collaborators.handlebars';
import languages_template from '~/templates/adminCategories-languages.handlebars';
import getReportSuperCategoryService from '~/services/reportCategoryService';
import getReportSubCategoryService from '~/services/reportSubCategoryService';
import getUtilsService from '~/services/utilsService';
import getLocalizationService from '~/services/localizationService';
import GeneralView from '~/generalView';

var AdminCategoriesView = GeneralView.View.extend({
	tagName: "div",
	className: 'select-category',
	user: null,
	superCategories: null,
	subCategories: null,
	selectedsubcat: null,
	categories: null,
	admincatusers : null,
	newIcon: null,
	updateIcon: null,
	superCategoryId: null,
	subCategoryId: null,
	typeModal: null,
	newNotCollaborators : null,
	newCollaborators : null,
	remCollaborators: null,
	catLangJson : null,
	qtys: [],
	params: {},

	initialize: function() {
		toastr.options = {
			"closeButton": true,
			"debug": false,
			"newestOnTop": true,
			"progressBar": false,
			"positionClass": "toast-top-center",
			"preventDuplicates": false,
			"onclick": null,
			"showDuration": "300",
			"hideDuration": "1000",
			"timeOut": "5000",
			"extendedTimeOut": "1000",
			"showEasing": "swing",
			"hideEasing": "linear",
			"showMethod": "fadeIn",
			"hideMethod": "fadeOut"
		}
	},

    events: {
		'click #savenewcatbtn' : 'savenewcat',
		'click #subcategoriesbtn' : 'subcategoriesview',
		'click #savenewsubcatbtn' : 'savenewsubcat',
		'click #deactivatecatbtn' : 'deactivatecat',
		'change #decategories' : 'showactivatedcatbtn',
		'change #categories' : 'changesupercat',
		'click #activatecatbtn' : 'activatecategory',
		'click #deactivatesubcatbtn': 'deactivatesubcat',
		'change #desubcategories' : 'showactivatedsubcatbtn',
		'change #subcategories' : 'showdeactivatesubcatbtn',
		'click #activatesubcatbtn' : 'activatesubcategory',
		'click #deactivatedctsttle' : "showdeactivatesubcats",
		'change #upload' : 'uploadFile',
		'click .discardicon' : 'discardfile',
		'click #categorybtn' : 'categoryview',
		'click #updatecatbtn' : 'updatecat',
		'change #upload2' : 'uploadFile2',
		'click .discardicon2' : 'discardfile2',
		'click #newcatbtn' : 'opennewcat',
		'click #newsubcatbtn' : 'opennewsubcat',
		'click #updatesubcatbtn': 'savesubcateadminbtn',
		'click #changenamesubcatbtn' : "openchangenamesubcat",
		'click #savenewsnameubcatbtn' : "savenewsubcatname",
		'click #collabcatadminbtn' : 'openmodalcollaborators',
		'click #collabsubcatadminbtn' : 'openmodalcollaborators',
		'click #collabnewcatadminbtn' : 'openmodalcollaborators',
		'click #collabnewsubcatadminbtn' : 'openmodalcollaborators',
		'click #langsubcatbtn' : function(){this.openlangmodal(true);},
		'click #langcatbtn' : function(){this.openlangmodal(false);},
		'click .markUser' : 'markUser',
		'click .add-collaborator' : 'addCollaborator',
		'click .rm-collaborator' : 'removeCollaborator',
		'click .mark-all' : 'markAll',
		'click .mark-none' : 'markNone',
		'change .radiolangs' : 'languageRadioChange',
		'click #setsubcattranslation' : 'languageSubcatEdit',
		'click #setcattranslation' : 'languageCatEdit',
	},

	render: function () {
		this.renderSupercategories();
		this.newIcon = null;
		this.updateIcon = null;
		this.user = Parse.User.current();
		$('#filenamef').empty();
		$('#myModal').hide();
		$('.modal-backdrop').hide();
		return this;
	},

	openchangenamesubcat: function(){
		var value = $('input[name=subcategories]:checked').val();
		var subcategory ='';
		for (var i = 0; i < this.subCategories.length; i++) {
			if(this.subCategories[i].id == value){
				subcategory = this.subCategories[i];
			}
		}
		$("#newnamesubcatinput").val(subcategory.attributes.name);
		$("#newprefixsubcatinput").val(subcategory.attributes.prefijo != undefined ? subcategory.attributes.prefijo : "");
	},

	savenewsubcatname: function(){
		var that = this;
		var value = $('input[name=subcategories]:checked').val();
		var newnamesubcat = $("#newnamesubcatinput").val();
		var newprefixsubcat = $("#newprefixsubcatinput").val();
		var xl = function(subCat){
			toastr.success("Subcategoría Actualizada Correctamente", "Operación realizada");
			$('#changenamesubcategorymodal').modal('hide');
			$('.modal').modal('hide');
			$('.modal-backdrop').remove();
			$('.radiolabel-'+value).html(newnamesubcat);
			for (var i = 0; i < that.subCategories.length; i++) {
				if(that.subCategories[i].id == value){
					that.subCategories[i] = subCat;
				}
			}
		};
		getReportSuperCategoryService().updateSubCategory(value, newnamesubcat, newprefixsubcat, xl);
	},

	opennewcat: function () {
		var that = this;
		$('#newcatinput').val(null);
		$('#newcatpre').val(null);
		$('#filenamef').empty();
		$('#imageFile').empty();
		this.newIcon = null;
		Parse.Cloud.run("getallusers", that.params).then(allusers => {
			this.admincatusers = allusers;
			this.newNotCollaborators = allusers;
			this.newCollaborators= [];
			var notCollaborators = allusers;
			$("#notcollaborators").html('');
			$("#collaborators").html('');
			for(var i = 0; i < notCollaborators.length; ++i){
				$('#notcollaborators').append('<li class="markUser" value="'+notCollaborators[i].id+'"><label>'+notCollaborators[i].attributes.username+'</label></li>');
			}
			$('.collaboratorsloader').hide();
		},
		(error) => {
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		});
	},

	opennewsubcat: function () {
		var that = this;
		$('#newsubcatinput').val(null);
		Parse.Cloud.run("getallusers", that.params).then(allusers => {
			this.admincatusers = allusers;
			this.newNotCollaborators = allusers;
			this.newCollaborators= [];
			var notCollaborators = allusers;
			$("#notcollaborators").html('');
			$("#collaborators").html('');
			for(var i = 0; i < notCollaborators.length; ++i){
				$('#notcollaborators').append('<li class="markUser" value="'+notCollaborators[i].id+'"><label>'+notCollaborators[i].attributes.username+'</label></li>');
			}
		},
		(error) => {
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		});
	},

	showdeactivatesubcats: function(){
		var x = $('.deactivatedcatscontainer').is(':visible');
		if (x) {
			$("#plusicon").attr('class', 'fa fa-plus iconx');
		}
		else {
			$("#plusicon").attr('class', 'fa fa-minus iconx');
		}
		$('.deactivatedcatscontainer').toggle();
		$('.decats').prop('checked', false);
		$('#activatecatbtncontainer').fadeOut();
	},

	activatecategory: function(){
		window.spinnerDialog.show();
		var value = $('input[name=decategories]:checked').val();
		if(value == null){
			window.spinnerDialog.hide();
			if( lang !='es'){
				toastr.info(arrlang[lang]["Selectcategoriemsg"],"Información");
			}else{
				toastr.info("Seleccionar una Categoría para Activarla.","Información");
			}
		}
		else {
			var that = this;
			toastr.options.timeOut = "0";
			toastr.options.extendedTimeOut = "0";
			toastr.options.closeButton = false;
			toastr.options.tapToDismiss = false;
			var txt = '<span>'+ arrlang[lang]["ActivateCategory"] +'</span><br><button class="btntoastr btnaccept" id="'+ value +'">'+ arrlang[lang]["ToastrAccept"] +'</button><button class="btntoastr btncancel">'+ arrlang[lang]["ToastrCancel"] +'</button>';
			this.toastrButtons(txt, 'sucess');
			$('.btnaccept').one("click", function(e){
				that.acceptButtonActivateCat(e);
			});
			$('.btncancel').one("click", function(){
				that.cancelButtonActivateCat();
			});
		}
	},

	acceptButtonActivateCat: function(e){
		toastr.options.timeOut = "5000";
		toastr.options.extendedTimeOut = "1000";
		toastr.options.closeButton = true;
		toastr.options.tapToDismiss = true;
		toastr.remove();
		var value = $(e.currentTarget).attr('id');
		var categoryobject ='';
		for (var i = 0; i < this.superCategories.length; i++) {
			if(this.superCategories[i].id == value){
				categoryobject=this.superCategories[i];
			}
		}
		categoryobject.parseObject.set('active',true);
		categoryobject.parseObject.save(null, {success: function(result){
			toastr.success(arrlang[lang]["Activatescategorymessage"],"Operación realizada");
		},
		error: function(result, error){
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		}});
		var that = this;
		that.$el.find('#AdminCats').modal('hide');
		setTimeout(function(){ window.spinnerDialog.hide(); that.renderSupercategories(); }, 1000);
	},

	cancelButtonActivateCat: function(){
		toastr.options.timeOut = "5000";
		toastr.options.extendedTimeOut = "1000";
		toastr.options.closeButton = true;
		toastr.options.tapToDismiss = true;
		toastr.remove();
		window.spinnerDialog.hide();
		toastr.error(arrlang[lang]["Activatesnocategoriemessage"],"");
	},

	activatesubcategory: function(){
		var value = $('input[name=desubcategories]:checked').val();
		if(value == null){
			if( lang !='es'){
				toastr.info(arrlang[lang]["Selectsubcattoactivate"],"Información");
			}
			else{
				toastr.info("Seleccionar una Subcategoría para Activarla.","Información");
			}
		}
		else{
			if( lang !='es'){
				if (arrlang[lang]["Activatesubcategorie"]) {
					var subcategoryobject ='';
					for (var i = 0; i < this.subCategories.length; i++) {
						if(this.subCategories[i].id == value){
							subcategoryobject=this.subCategories[i];
						}
					}
					subcategoryobject.parseObject.set('active',true);
					subcategoryobject.parseObject.save(null, {success: function(result){
						if( lang !='es'){
							toastr.info(arrlang[lang]["Subcategorieactivated"],"Información");
						}else{
							toastr.info('Subategoria activada',"Información");
						}
					},
					error: function(result, error){
						console.log(error);
						switch(error.code){
							case 100:
								toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
							break;
						}
					}});
					$('#activatesubcatbtncontainer').fadeOut();
					var that = this;
					setTimeout(function(){ that.subcategoriesview(); }, 1000);
				}
				else {
					toastr.error(arrlang[lang]["Subcategorienoactivated"],"error");
				}
			}
			else{
				var that = this;
				toastr.options.timeOut = "0";
				toastr.options.extendedTimeOut = "0";
				var txt = '<span>'+ arrlang[lang]["ActivateSubCategory"] +'</span><br><button class="btntoastr btnaccept" id="'+ value +'">'+ arrlang[lang]["ToastrAccept"] +'</button><button class="btntoastr btncancel">'+ arrlang[lang]["ToastrCancel"] +'</button>';
				this.toastrButtons(txt, 'sucess');
				$('.btnaccept').one("click", function(e){
					that.acceptButtonActivateSubCat(e);
				});
				$('.btncancel').one("click", function(){
					that.cancelButtonActivateSubCat();
				});
			}
		}
	},

	acceptButtonActivateSubCat: function(e){
		toastr.options.timeOut = "5000";
		toastr.options.extendedTimeOut = "1000";
		var value = $(e.currentTarget).attr('id');
		var subcategoryobject ='';
		for (var i = 0; i < this.subCategories.length; i++) {
			if(this.subCategories[i].id == value){
				subcategoryobject=this.subCategories[i];
			}
		}
		subcategoryobject.parseObject.set('active',true);
		subcategoryobject.parseObject.save(null, {success: function(result){
			if( lang !='es'){
				toastr.success(arrlang[lang]["AsignedReportMessage"],"Operación realizada");
			}else{
				toastr.success('Subategoria activada',"Operación realizada");
			}
		},
		error: function(result, error){
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		}});
		$('#activatesubcatbtncontainer').fadeOut();
		var that = this;
		setTimeout(function(){ that.subcategoriesview(); }, 1000);
	},

	cancelButtonActivateSubCat: function(){
		toastr.options.timeOut = "5000";
		toastr.options.extendedTimeOut = "1000";
		toastr.error('Subcategoría no activada',"");
	},

	deactivatecat: function(){
		window.spinnerDialog.show();
		var value = $('input[name=categories]:checked').val();
		if(value == null){
			window.spinnerDialog.hide();
			if( lang !='es'){
				toastr.info(arrlang[lang]["SelectCategorietodeactivated"],"Información");
			}
			else{
				toastr.info("Seleccionar una Categoría para Desactivarla.","Información");
			}
		}
		else{
			var that = this;
			toastr.options.timeOut = "0";
			toastr.options.extendedTimeOut = "0";
			toastr.options.closeButton = false;
			toastr.options.tapToDismiss = false;
			var txt = '<span>'+ arrlang[lang]["Deactivatecategory"] +'</span><br><button class="btntoastr btnaccept" id="'+ value +'">'+ arrlang[lang]["ToastrAccept"] +'</button><button class="btntoastr btncancel">'+ arrlang[lang]["ToastrCancel"] +'</button>';
			this.toastrButtons(txt, 'sucess');
			$('.btnaccept').one("click", function(e){
				that.acceptButtonDeactivateCat(e);
			});
			$('.btncancel').one("click", function(){
				that.cancelButtonDeactivateCat();
			});
		}
	},

	acceptButtonDeactivateCat: function(e){
		toastr.options.timeOut = "5000";
		toastr.options.extendedTimeOut = "1000";
		toastr.options.closeButton = true;
		toastr.options.tapToDismiss = true;
		var value = $(e.currentTarget).attr('id');
		toastr.remove();
		var categoryobject ='';
		for (var i = 0; i < this.superCategories.length; i++) {
			if(this.superCategories[i].id == value){
				categoryobject=this.superCategories[i];
			}
		}
		categoryobject.parseObject.set('active',false);
		categoryobject.parseObject.save(null, {success: function(result){
			if( lang !='es'){
				toastr.success(arrlang[lang]["CategoryDeactivated"],"Operación realizada");
			}else{
				toastr.success('Categoria Desactivada',"Operación realizada");
			}
		},
		error: function(result, error){
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		}});
		var that = this;
		that.$el.find('#AdminCats').modal('hide');
		setTimeout(function(){ window.spinnerDialog.hide(); that.renderSupercategories(); }, 1000);
	},

	cancelButtonDeactivateCat: function(){
		toastr.options.timeOut = "5000";
		toastr.options.extendedTimeOut = "1000";
		toastr.options.closeButton = true;
		toastr.options.tapToDismiss = true;
		toastr.remove();
		window.spinnerDialog.hide();
		toastr.error(arrlang[lang]["CategorynoDeactivated"],"");
	},

	deactivatesubcat: function(){
		var value = $('input[name=subcategories]:checked').val();
		if(value == null){
			if( lang !='es'){
				toastr.info(arrlang[lang]["SelectSubCategorietodeactivated"],"Información");
			}
			else{
				toastr.info("Seleccionar una Subcategoría para Desactivarla.","Información");
			}
		}
		else{
			var that = this;
			toastr.options.timeOut = "0";
			toastr.options.extendedTimeOut = "0";
			var txt = '<span>'+ arrlang[lang]["DeactivateSubcategory"] +'</span><br><button class="btntoastr btnaccept" id="'+ value +'">'+ arrlang[lang]["ToastrAccept"] +'</button><button class="btntoastr btncancel">'+ arrlang[lang]["ToastrCancel"] +'</button>';
			this.toastrButtons(txt, 'sucess');
			$('.btnaccept').one("click", function(e){
				that.acceptButtonDeactivateSubCat(e);
			});
			$('.btncancel').one("click", function(){
				that.cancelButtonDeactivateSubCat();
			});
		}
	},

	acceptButtonDeactivateSubCat: function(e){
		toastr.options.timeOut = "5000";
		toastr.options.extendedTimeOut = "1000";
		var value = $(e.currentTarget).attr('id');
		var subcategoryobject ='';
		for (var i = 0; i < this.subCategories.length; i++) {
			if(this.subCategories[i].id == value){
				subcategoryobject=this.subCategories[i];
			}
		}
		subcategoryobject.parseObject.set('active',false);
		subcategoryobject.parseObject.save(null, {success: function(result){
			if( lang !='es'){
				toastr.success(arrlang[lang]["SubcategoryDeactivated"],"Operación Realizada");
			}else{
				toastr.success('Subategoria Desactivada',"Operación Realizada");
			}
		},
		error: function(result, error){
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		}});
		var that = this;
		setTimeout(function(){ that.subcategoriesview(); }, 1000);
	},

	cancelButtonDeactivateSubCat: function(){
		toastr.options.timeOut = "5000";
		toastr.options.extendedTimeOut = "1000";
		toastr.error(arrlang[lang]["SubCategorynoDeactivated"],"");
	},

	categoryview: function(){
		$('.optionsincontainersubcat').hide();
		$('.optionsincontainersupcat').show();
		var that = this;
		var value = $('input[name=categories]:checked').val();
		this.$el.find('#admincatid').text(value);
		if(value == null){
			if( lang !='es'){
				toastr.info(arrlang[lang]["SelectCategorietoseeadmin"],"Información")
			}else{
				toastr.info("Seleccionar una Categoría para administrarla.","Información")
			}
		}else{
			var name = '';
			var pre = '';
			var icon = '';
			for (var i = 0; i < this.superCategories.length; i++) {
				if(this.superCategories[i].id == value){
					name=this.superCategories[i].attributes.name;
					this.$el.find('#updatecatinput').val(this.superCategories[i].attributes.name);
					this.$el.find('#updatecatpre').val(this.superCategories[i].attributes.prefijo);
					this.updateIcon = this.superCategories[i].attributes.iconFile;;
					if(this.updateIcon){
						$('#updatefilenamef').fadeIn();
						$('#updatefilenamef').empty();
						$('#updatefilenamef').append("<div class='pull-left action remove-report discardicon2' id='File'  title='Descartar archivo'> File</div><br><div class='separator2></div>");
						$(".discardicon2").hover(function(){
							$(this).css("color", "#2F4F4F ");
							$(this).css("cursor", "pointer");
						}, function(){
							$(this).css("color", "inherit");
						});
						$('#imageFile2').fadeIn();
						$('#imageFile2').empty();
						$('#imageFile2').append('<img id="viewIcon" src="'+this.updateIcon._url+'">');
					}
					var username;
					var varx;
					that.superCategoryId = that.superCategories[i].id;
					that.refreshcollaborators(that.superCategories[i]);
				}
			}
			if( lang !='es'){
				this.$el.find('#admincatTittle').text(arrlang[lang]["AdminCategoryTittle"]+" "+name);
			}else{
				this.$el.find('#admincatTittle').text("Administrar Categoría "+name);
			}
		}
	},

	setcollabs: function(notCollaborators, collaborators){
		var that = this;
		for(var x = 0; x < notCollaborators.length; ++x){
			if (Settings.shogunmonitorapp && Parse.User.current().attributes.role != 'Administrador General') {
				if (notCollaborators[x].attributes.supercategory == that.user.attributes.supercategory && Settings.shogunmonitorapp && that.user.attributes.supercategory != undefined) {
					$('#notcollaborators').append('<li class="markUser" value="'+notCollaborators[x].id+'"><label>'+notCollaborators[x].attributes.username+'</label></li>');
				}
			}else {
				$('#notcollaborators').append('<li class="markUser" value="'+notCollaborators[x].id+'"><label>'+notCollaborators[x].attributes.username+'</label></li>');
			}
		}
		for(var i = 0; i < collaborators.length; ++i){
			if (Settings.shogunmonitorapp && Parse.User.current().attributes.role != 'Administrador General') {
				if (collaborators[i].attributes.supercategory == that.user.attributes.supercategory && Settings.shogunmonitorapp && that.user.attributes.supercategory != undefined) {
					$("#collaborators").append("<li class='markUser' value='"+collaborators[i].id+"'><label>"+collaborators[i].attributes.username+"</label></li>");
				}
			}else {
				$("#collaborators").append("<li class='markUser' value='"+collaborators[i].id+"'><label>"+collaborators[i].attributes.username+"</label></li>");
			}
		}
	},

	refreshcollaborators: function(supcat){
		var that = this;
		var queryPromise = supcat.attributes.collaborators.query().find();
		Parse.Promise.when(queryPromise).then((collaborators) => {
			Parse.Cloud.run("getallusers", that.params).then((allusers) => {
				var notCollaborators = allusers;
				for(var i = 0; i < collaborators.length; ++i){
					for(var j = 0; j < notCollaborators.length; ++j){
						if(collaborators[i].id == notCollaborators[j].id){
							notCollaborators.splice(j, 1);
						}
					}
				}
				$("#notcollaborators").html('');
				$("#collaborators").html('');
				that.setcollabs(notCollaborators, collaborators);
			},
			(error) => {
				console.log(error);
				switch(error.code){
					case 100:
						toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
					break;
				}
			});
			$('.collaboratorsloader').hide();
		},
		(error) => {
			console.log(error);
			switch(error[0].code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		});
	},

	updatecat: function(){
		var selectedsupercategorid = $('input[name="categories"]:checked').val();
		var newcatName = $('#updatecatinput').val();
		var newcatPre = $('#updatecatpre').val();
		var newcatIcon = this.updateIcon;
		this.updateIcon = null;
		if(newcatName == ""){
			if( lang !='es'){
				toastr.info(arrlang[lang]["Pleaseentercatname"],"Información");
			}else{
				toastr.info("Por favor ingresar un nombre a la categoría","Información");
			}
		}else{
			if(newcatPre== ""){
				if( lang !='es'){
					toastr.info(arrlang[lang]["Pleaseentercatprename"],"Información");
				}else{
					toastr.info("Por favor ingresar un Prefijo a la categoría","Información");
				}
			}else{
				var newcatNameUpper = newcatName;
				var newcatPreUpper = newcatPre;
				getReportSuperCategoryService().updateCategory(selectedsupercategorid, newcatNameUpper, newcatPreUpper, newcatIcon);
				var that = this;
				that.$el.find('#AdminCats').modal('hide');
				setTimeout(function(){ that.renderSupercategories(); }, 1000);
			}
		}
	},

	uploadFile2: function(e){
		var that = this;
		var reader = new FileReader();
		var namelenght = e.target.files[0].name.length;
		this.filescont++;
		var extension = e.target.files[0].name.substring(namelenght-4, namelenght);
		if (extension.charAt(0) != '.'){
			var extension = e.target.files[0].name.substring(namelenght-5, namelenght);
		}
		var name = 'FileNews_'+this.filescont+extension;
		$('#updatefilenamef').fadeIn();
		$('#updatefilenamef').empty();
		$('#updatefilenamef').append("<div class='pull-left action remove-report discardicon2' id='"+name+"'  title='Descartar archivo'> "+ name +"</div><br><div class='separator2></div>");
		$(".discardicon2").hover(function(){
			$(this).css("color", "#2F4F4F ");
			$(this).css("cursor", "pointer");
		}, function(){
			$(this).css("color", "inherit");
		});
		that.previewImage2(e.target.files[0]);
		reader.onload = function (e) {
			var byteArray = new Uint8Array(e.target.result);
			var output = new Array(byteArray.length);
			var i = 0;
			var n = output.length;
			while (i < n) {
				output[i] = byteArray[i];
				i++;
			}
			var parseFile = new Parse.File(name, output);
			that.updateIcon = parseFile;
		};
		reader.readAsArrayBuffer(e.target.files[0]);
	},

	previewImage2: function(e){
		var reader = new FileReader();
		reader.onload = function (e) {
			$('#imageFile2').fadeIn();
			$('#imageFile2').empty();
			$('#imageFile2').append('<img id="viewIcon" src="'+e.target.result+'">');
		};
		reader.readAsDataURL(e);
	},

	discardfile2: function(e){
		e.currentTarget.remove();
		$('#imageFile2').empty();
		$('#imageFile2').fadeOut();
		this.updateIcon = null;
	},

	subcategoriesview: function(){
		$('.optionsincontainersupcat').hide()
		$('.optionsincontainersubcat').show();
		$('#selectusersforsubcat').hide();
		$('#updatesubcatbtn').hide();
		$('#selectcollaboratorssubcat').css('display','none');
		$('#deactivatesubcatbtn').prop('disabled', true);
		$('#changenamesubcatbtn').prop('disabled', true);
		$('#langsubcatbtn').prop('disabled', true);
		var value = $('input[name=categories]:checked').val();
		this.$el.find('#supercatid').text(value);
		if(value == null){
			if( lang !='es'){
				toastr.info(arrlang[lang]["SelectCategorietoseesubcategories"],"Información")
			}
			else{
				toastr.info("Seleccionar una Categoría para ver sus Subcategorías.","Información")
			}
			var that = this;
			setTimeout(function(){ that.$el.find('#subcategoriesmodal').modal('hide');  }, 500);
		}
		else{
			this.superCategoryId = value;
			var name = '';
			for (var i = 0; i < this.superCategories.length; i++) {
				if(this.superCategories[i].id == value){
					name=this.superCategories[i].attributes.name;
				}
			}
			if( lang !='es'){
				this.$el.find('#newsubcatTittle').text(arrlang[lang]["Subcateogiresfor"]+" "+name);
			}
			else{
				this.$el.find('#newsubcatTittle').text("Subcategorías para: "+name);
			}
			var handlebarsTemplate = Handlebars.template(admincategories_template);
			var handlebarsTemplate2 = Handlebars.template(collaborators_template);
			getReportSubCategoryService().fetch({
				all: true,
				cache: false,
				rules: {
					equals: [{
						key: 'superCat',
						val: {
							__type: "Pointer",
							className: "superCategory",
							objectId: value
						}
					}]
				}
			}).then(subcategory => {
				this.subCategories = subcategory.models;
				if(subcategory.length == 0){
					$('#subcates').empty();
					$('#subuncates').empty();
					if( lang !='es'){
						this.$el.find('#catsubtittlex').text(arrlang[lang]["Categoriewithnosubcategoires"]);
					}
					else{
						this.$el.find('#catsubtittlex').text('Esta Categoría no tiene Subcategorías.');
					}
				}
				else{
					$('#subcates').empty();
					$('#subuncates').empty();
					this.$el.find('#catsubtittlex').text('Seleccionar una Subcategoría');
					var bol =false;
					for (var i = 0; i < subcategory.models.length; i++){
						if (subcategory.models[i].attributes.active) {
							$('#subcates').append("<input type='radio' class='subcats' id='subcategories' name='subcategories' value= '"+subcategory.models[i].id+"'><span class='radiolabel-"+ subcategory.models[i].id +"'>"+ subcategory.models[i].attributes.name +"</span><br><br>");
						}
						else{
							$('#subuncates').append("<input type='radio' class='desubcats' id='desubcategories' name='desubcategories' value= '"+subcategory.models[i].id+"'><span class='radiolabel-"+ subcategory.models[i].id +"'>"+subcategory.models[i].attributes.name+"</span><br><br>");
							bol =true;
						}
					}
					if (bol == true) {
						$('#deactivatedsubctsttle').show();
					}
					else{
						$('#deactivatedsubctsttle').fadeOut();
					}
				}
			},
			(error) => {
				console.log(error);
				switch(error.code){
					case 100:
						toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
					break;
					default:
						this.$el.html(handlebarsTemplate(null));
						$("#collaboratorsModalContainer").append(handlebarsTemplate2(null));
					break;
				}
			});
		}
	},

	savenewsubcat: function(){
		var newsubcatinput = $('#newsubcatinput').val();
		var supercatid = $('#supercatid').text();
		if(newsubcatinput == ""){
			if( lang !='es'){
				toastr.info(arrlang[lang]["Pleaseentersubcatname"],"Información");
			}else{
				toastr.info("Por favor ingresar un nombre a la nueva Subcategoría","Información");
			}
		}else{
			getReportSubCategoryService().setNewSubCategory(newsubcatinput, this.newCollaborators, {
				__type: "Pointer",
				className: "superCategory",
				objectId: supercatid
			});
			var that = this;
			setTimeout(function(){ that.subcategoriesview(); }, 1000);
		}
	},

	showactivatedcatbtn: function(){
		$('.cats').prop('checked', false);
		$('#activatecatbtncontainer').fadeIn();
	},

	changesupercat: function(){
		$('.decats').prop('checked', false);
		$('#activatecatbtncontainer').fadeOut();
		$('.optionsincontainer').show();
		$('.optionsincontainersubcat').hide();
		$('.optionsincontainersupcat').hide();
		$(".admincatoptcontainer").css("visibility", "visible");
		$(".admincatactioncontainer").css("visibility", "visible");
		this.categoryview();
	},

	showactivatedsubcatbtn: function(){
		$('.subcats').prop('checked', false);
		$('#activatesubcatbtncontainer').fadeIn();
		$('#deactivatesubcatbtn').prop('disabled', true);
	},

	showdeactivatesubcatbtn: function(e){
		var that = this;
		this.selectedsubcat = e.target.defaultValue;
		var selectedsubcateg = '';
		for (var i = 0; i < this.subCategories.length; i++) {
			if (this.subCategories[i].id == e.target.defaultValue ) {
				selectedsubcateg = this.subCategories[i];
				this.subCategoryId = this.subCategories[i].id;
			}
		}
		$('#selectcollaboratorssubcat').css('display','flex');
		$('#selectusersforsubcat').show();
		$('#updatesubcatbtn').show();
		$('#selectcollaboratorssubcat').css('display','flex');
		var queryPromise = selectedsubcateg.attributes.collaborators.query().find();
		Parse.Promise.when(queryPromise).then((collaborators) => {
			Parse.Cloud.run("getallusers", that.params).then(allusers => {
				var notCollaborators = allusers;
				for(var i = 0; i < collaborators.length; ++i){
					for(var j = 0; j < notCollaborators.length; ++j){
						if(collaborators[i].id == notCollaborators[j].id){
							notCollaborators.splice(j, 1);
						}
					}
				}
				$("#notcollaborators").html('');
				$("#collaborators").html('');
				that.setcollabs(notCollaborators, collaborators);
			},
			(error) => {
				console.log(error);
				switch(error.code){
					case 100:
						toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
					break;
				}
			});
		},
		(error) => {
			console.log(error);
			switch(error[0].code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		});
		$('.collaboratorsloader').hide();
		$('.desubcats').prop('checked', false);
		$('#activatesubcatbtncontainer').fadeOut();
		$('#deactivatesubcatbtn').prop('disabled', false);
		$('#changenamesubcatbtn').prop('disabled', false);
		$('#langsubcatbtn').prop('disabled', false);
	},

	uploadFile: function(e){
  		var that = this;
  		var reader = new FileReader();
		var namelenght = e.target.files[0].name.length;
		this.filescont++;
		var extension = e.target.files[0].name.substring(namelenght-4, namelenght);
		if (extension.charAt(0) != '.'){
			var extension = e.target.files[0].name.substring(namelenght-5, namelenght);
		}
		var name = 'FileCategory_'+this.filescont+extension;
		$('#filenamef').fadeIn();
		$('#filenamef').empty();
		$('#filenamef').append("<div class='pull-left action remove-report discardicon' id='"+name+"'  title='Descartar archivo'> "+ name +"</div><br><div class='separator2></div>");
		$(".discardicon").hover(function(){
			$(this).css("color", "#2F4F4F ");
			$(this).css("cursor", "pointer");
		}, function(){
			$(this).css("color", "inherit");
		});
		that.previewImage(e.target.files[0]);
		reader.onload = function (e) {
  			var byteArray = new Uint8Array(e.target.result);
  			var output = new Array(byteArray.length);
  			var i = 0;
  			var n = output.length;
  			while (i < n) {
  				output[i] = byteArray[i];
  				i++;
  			}
  			var parseFile = new Parse.File(name, output);
  			that.newIcon = parseFile;
  		};
  		reader.readAsArrayBuffer(e.target.files[0]);
	},

	previewImage: function(e){
		var reader = new FileReader();
		reader.onload = function (e) {
			$('#imageFile').fadeIn();
			$('#imageFile').empty();
			$('#imageFile').append('<img id="viewIcon" src="'+e.target.result+'">');
		};
		reader.readAsDataURL(e);
	},

	discardfile: function(e){
		e.currentTarget.remove();
		$('#imageFile').empty();
		$('#imageFile').fadeOut();
		this.newIcon = null;
	},

	savenewcat: function(){
		var newcatName = $('#newcatinput').val();
		var newcatPre = $('#newcatpre').val();
		var newcatIcon = this.newIcon;
		if(newcatName == ""){
			if( lang !='es'){
				toastr.info(arrlang[lang]["Pleaseentercatname"],"Información");
			}
			else{
				toastr.info("Por favor ingresar un nombre a la nueva categoría","Información");
			}
		}
		else{
			if(newcatPre== ""){
				if( lang !='es'){
					toastr.info(arrlang[lang]["Pleaseentercatprename"],"Información");
				}
				else{
					toastr.info("Por favor ingresar un Prefijo a la nueva categoría","Información");
				}
			}
			else{
				if(this.newCollaborators.length === 0){
					toastr.info("Por favor ingresar al menos un colaborador");
				}
				else{
					this.newIcon = null;
					var newcatNameUpper = newcatName;
					var newcatPreUpper = newcatPre;
					getReportSuperCategoryService().setNewCategory(newcatNameUpper, newcatPreUpper, newcatIcon, this.newCollaborators);
					var that = this;
					$('#newcategorymodal').modal('hide');
					$('body').removeClass('modal-open');
					$('.modal-backdrop').remove();
					setTimeout(function(){ that.renderSupercategories(); }, 1000);
				}
			}
		}
	},

	renderSupercategories: function() {
		var that = this;
		var permissions = getUtilsService.getprofilepermissions();
		if (Settings.shogunmonitorapp && !permissions.accessallreports) {
			that.params.shogunmonitorapp = true;
		}
		else{
			var handlebarsTemplate = Handlebars.template(admincategories_template);
			this.$el.html(handlebarsTemplate());
			this.$el.find('.admincatscontainer').hide();
		}
		var superCategoryPromise = getReportSuperCategoryService().fetch({
			all: true,
			cache: false
		}).then(superCategories => {
			Parse.Cloud.run("getallusers", that.params).then(allusers => {
				this.admincatusers = allusers;
				var handlebarsTemplate = Handlebars.template(admincategories_template);
				var handlebarsTemplate2 = Handlebars.template(collaborators_template);
				this.superCategories = superCategories.models;
				if(!permissions.accessallreports){
					var usercateg = [];
					for (var i = 0; i < permissions.categories.length; i++) {
						for (var ii = 0; ii < superCategories.models.length; ii++) {
							if(permissions.categories[i] == superCategories.models[ii].id){
								usercateg.push(superCategories.models[ii]);
							}
						}
					}
					superCategories.models = [];
					superCategories.models = usercateg;
				}
				this.$el.html(handlebarsTemplate({
					models: superCategories.models,
					users: allusers
				}));
				$('.admincatloader').hide();
				if(Settings.shogunmonitorapp && Parse.User.current().attributes.role != 'Administrador General'){

				}
				$("#collaboratorsModalContainer").append(handlebarsTemplate2(null));
				if(!permissions.accessallreports){
					$('#newcatbtn').hide();
					$('#deactivatecatbtn').hide();
					$('#deactivatedctsttle').hide();
				}
				this.translate();
				this.function();
				var icons = this.$el.find('.icon');
				for (var i = 0; i < icons.length; ++i) {
					$(icons[i]).append(superCategories.models[i].attributes.icon);
				}
			},
			(error) => {
				console.log(error);
				switch(error.code){
					case 100:
						toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
					break;
				}
			});
		},
		(error) => {
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		});
	},

	openmodalcollaborators: function(e){
		var value = e.currentTarget.getAttribute("value");
		this.typeModal = value;
		var listElements = $('ul .markUser');
		for(var i = 0; i < listElements.length; ++i){
			listElements[i].classList.remove("selected");
		}
		document.getElementsByClassName("add-collaborator")[0].disabled = true;
		document.getElementsByClassName("rm-collaborator")[0].disabled = true;
		document.getElementsByClassName("mark-all")[0].disabled = false;
		document.getElementsByClassName("mark-none")[0].disabled = true;
		document.getElementsByClassName("mark-none")[1].disabled = true;
	},

	markUser: function(e){
		var markElement = e.currentTarget;
		markElement.classList.toggle("selected");
		var listElements = e.currentTarget.parentElement.getElementsByClassName("markUser");
		var buttonsArray = markElement.parentElement.parentElement.previousElementSibling;
		var addCollaborator = buttonsArray.getElementsByClassName("add-collaborator")[0];
		var removeCollaborator = buttonsArray.getElementsByClassName("rm-collaborator")[0];
		var markNone = buttonsArray.getElementsByClassName("mark-none")[0];
		var markAll = buttonsArray.getElementsByClassName("mark-all")[0];
		if(addCollaborator){
			addCollaborator.disabled = false;
		}
		if(removeCollaborator){
			removeCollaborator.disabled = false;
		}
		markNone.disabled = false;
		if(markAll){
			markAll.disabled = false;
		}
		if(markElement.parentElement.getElementsByClassName("selected").length == 0){
			if(addCollaborator){
				addCollaborator.disabled = true;
			}
			if(removeCollaborator){
				removeCollaborator.disabled = true;
			}
			markNone.disabled = true;
		}
		if(markElement.parentElement.getElementsByClassName("selected").length == listElements.length){
			if(markAll){
				markAll.disabled = true;
			}
		}
	},

	markAll: function(e){
		var listElements = e.currentTarget.parentElement.nextElementSibling.getElementsByClassName("markUser");
		for(var i = 0; i < listElements.length; ++i){
			listElements[i].classList.add("selected");
		}
		var buttonsArray = e.currentTarget.parentElement;
		var addCollaborator = buttonsArray.getElementsByClassName("add-collaborator")[0];
		var removeCollaborator = buttonsArray.getElementsByClassName("rm-collaborator")[0];
		var markNone = buttonsArray.getElementsByClassName("mark-none")[0];
		var markAll = buttonsArray.getElementsByClassName("mark-all")[0];
		if(addCollaborator){
			addCollaborator.disabled = false;
		}
		if(removeCollaborator){
			removeCollaborator.disabled = false;
		}
		markNone.disabled = false;
		if(markAll){
			markAll.disabled = true;
		}
	},

	markNone: function(e){
		var listElements = e.currentTarget.parentElement.nextElementSibling.getElementsByClassName("markUser");
		for(var i = 0; i < listElements.length; ++i){
			listElements[i].classList.remove("selected");
		}
		var buttonsArray = e.currentTarget.parentElement;
		var addCollaborator = buttonsArray.getElementsByClassName("add-collaborator")[0];
		var removeCollaborator = buttonsArray.getElementsByClassName("rm-collaborator")[0];
		var markNone = buttonsArray.getElementsByClassName("mark-none")[0];
		var markAll = buttonsArray.getElementsByClassName("mark-all")[0];
		if(addCollaborator){
			addCollaborator.disabled = true;
		}
		if(removeCollaborator){
			removeCollaborator.disabled = true;
		}
		markNone.disabled = true;
		if(markAll){
			markAll.disabled = false;
		}
	},

	addCollaborator: function(e){
		switch(this.typeModal){
			case '0':
				this.addCollaboratorSuperCat(e);
			break;
			case '1':
				this.addCollaboratorSubCat(e);
			break;
			case '2':
				this.addCollaboratorNewSuperCat(e);
			break;
			case '3':
				this.addCollaboratorNewSubCat(e);
			break;
		}
	},

	addCollaboratorSuperCat: function(e){
		//agregar a la base de datos
		var that = this;
		var listElements = e.currentTarget.parentElement.nextElementSibling.getElementsByClassName("selected");
		var listIds = [];
		for(var i = 0; i < listElements.length; ++i){
			listIds.push(listElements[i].getAttribute("value"));
		}
		Parse.Cloud.run("addCollaboratorSuperCategory", { 'categoryId': that.superCategoryId, 'listUsers': listIds }).then(function(result) {
			toastr.success("Colaboradores agregados satisfactoriamente","Operación realizada");
			var superCategoryPromise = getReportSuperCategoryService().fetch({
				all: true,
				cache: false,
				rules: {
					equals: [{
						key: 'objectId',
						val: that.superCategoryId
					}]
				}
			}).then(superCategory => {
				for (var i = 0; i < that.superCategories.length; i++) {
					if(that.superCategories[i].id == superCategory.models[0].id){
						that.superCategories[i] = superCategory.models[0];
					}
				}
				var queryPromise = superCategory.models[0].attributes.collaborators.query().find();
				Parse.Promise.when(queryPromise).then((collaborators) => {
					Parse.Cloud.run("getallusers", that.params).then(allusers => {
						var notCollaborators = allusers;
						for(var i = 0; i < collaborators.length; ++i){
							for(var j = 0; j < notCollaborators.length; ++j){
								if(collaborators[i].id == notCollaborators[j].id){
									notCollaborators.splice(j, 1);
								}
							}
						}
						$("#notcollaborators").html('');
						$("#collaborators").html('');
						that.setcollabs(notCollaborators, collaborators);
					},
					(error) => {
						console.log(error);
						switch(error.code){
							case 100:
								toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
							break;
						}
					});
				},
				(error) => {
					console.log(error);
					switch(error.code){
						case 100:
							toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
						break;
					}
				});
			},
			(error) => {
				console.log(error);
				switch(error.code){
					case 100:
						toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
					break;
				}
			});
		},
		(error) => {
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		});
		document.getElementsByClassName("add-collaborator")[0].disabled = true;
		document.getElementsByClassName("rm-collaborator")[0].disabled = true;
		document.getElementsByClassName("mark-all")[0].disabled = false;
		document.getElementsByClassName("mark-none")[0].disabled = true;
		document.getElementsByClassName("mark-none")[1].disabled = true;
	},

	addCollaboratorSubCat: function(e){
		//agregar a la base de datos
		var that = this;
		var listElements = e.currentTarget.parentElement.nextElementSibling.getElementsByClassName("selected");
		var listIds = [];
		for(var i = 0; i < listElements.length; ++i){
			listIds.push(listElements[i].getAttribute("value"));
		}
		Parse.Cloud.run("addCollaboratorSubCategory", { 'subCategoryId': that.subCategoryId, 'listUsers': listIds }).then(function(result) {
			toastr.success("Colaboradores agregados satisfactoriamente","Operación realizada");
			var subCategoryPromise = getReportSubCategoryService().fetch({
				all: true,
				cache: false,
				rules: {
					equals: [{
						key: 'objectId',
						val: that.subCategoryId
					}]
				}
			}).then(subCategory => {
				for (var i = 0; i < that.subCategories.length; i++) {
					if(that.subCategories[i].id == subCategory.models[0].id){
						that.subCategories[i] = subCategory.models[0];
					}
				}
				var queryPromise = subCategory.models[0].attributes.collaborators.query().find();
				Parse.Promise.when(queryPromise).then((collaborators) => {
					Parse.Cloud.run("getallusers", that.params).then(allusers => {
						var notCollaborators = allusers;
						for(var i = 0; i < collaborators.length; ++i){
							for(var j = 0; j < notCollaborators.length; ++j){
								if(collaborators[i].id == notCollaborators[j].id){
									notCollaborators.splice(j, 1);
								}
							}
						}
						$("#notcollaborators").html('');
						$("#collaborators").html('');
						that.setcollabs(notCollaborators, collaborators);
					},
					(error) => {
						console.log(error);
						switch(error.code){
							case 100:
								toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
							break;
						}
					});
				},
				(error) => {
					console.log(error);
					switch(error.code){
						case 100:
							toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
						break;
					}
				});
			},
			(error) => {
				console.log(error);
				switch(error.code){
					case 100:
						toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
					break;
				}
			});
		},
		(error) => {
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		});
		document.getElementsByClassName("add-collaborator")[0].disabled = true;
		document.getElementsByClassName("rm-collaborator")[0].disabled = true;
		document.getElementsByClassName("mark-all")[0].disabled = false;
		document.getElementsByClassName("mark-none")[0].disabled = true;
		document.getElementsByClassName("mark-none")[1].disabled = true;
	},

	addCollaboratorNewSuperCat: function(e){
		//agregar a la base de datos
		var that = this;
		var listElements = e.currentTarget.parentElement.nextElementSibling.getElementsByClassName("selected");
		var listIds = [];
		for(var i = 0; i < listElements.length; ++i){
			listIds.push(listElements[i].getAttribute("value"));
		}
		var notCollaborators = this.newNotCollaborators;
		var collaborators = this.newCollaborators;
		for(var i = 0; i < listIds.length; ++i){
			for(var j = 0; j < notCollaborators.length; ++j){
				if(listIds[i] == notCollaborators[j].id){
					collaborators.push(notCollaborators[j]);
				}
			}
		}
		for(var i = 0; i < collaborators.length; ++i){
			for(var j = 0; j < notCollaborators.length; ++j){
				if(collaborators[i].id == notCollaborators[j].id){
					notCollaborators.splice(j, 1);
				}
			}
		}
		this.newNotCollaborators = notCollaborators;
		this.newCollaborators= collaborators;
		$("#notcollaborators").html('');
		$("#collaborators").html('');
		that.setcollabs(notCollaborators, collaborators);
		document.getElementsByClassName("add-collaborator")[0].disabled = true;
		document.getElementsByClassName("rm-collaborator")[0].disabled = true;
		document.getElementsByClassName("mark-all")[0].disabled = false;
		document.getElementsByClassName("mark-none")[0].disabled = true;
		document.getElementsByClassName("mark-none")[1].disabled = true;
	},

	addCollaboratorNewSubCat: function(e){
		//agregar a la base de datos
		var that = this;
		var listElements = e.currentTarget.parentElement.nextElementSibling.getElementsByClassName("selected");
		var listIds = [];
		for(var i = 0; i < listElements.length; ++i){
			listIds.push(listElements[i].getAttribute("value"));
		}
		var notCollaborators = this.newNotCollaborators;
		var collaborators = this.newCollaborators;
		for(var i = 0; i < listIds.length; ++i){
			for(var j = 0; j < notCollaborators.length; ++j){
				if(listIds[i] == notCollaborators[j].id){
					collaborators.push(notCollaborators[j]);
				}
			}
		}
		for(var i = 0; i < collaborators.length; ++i){
			for(var j = 0; j < notCollaborators.length; ++j){
				if(collaborators[i].id == notCollaborators[j].id){
					notCollaborators.splice(j, 1);
				}
			}
		}
		this.newNotCollaborators = notCollaborators;
		this.newCollaborators= collaborators;
		$("#notcollaborators").html('');
		$("#collaborators").html('');
		that.setcollabs(notCollaborators, collaborators);
		document.getElementsByClassName("add-collaborator")[0].disabled = true;
		document.getElementsByClassName("rm-collaborator")[0].disabled = true;
		document.getElementsByClassName("mark-all")[0].disabled = false;
		document.getElementsByClassName("mark-none")[0].disabled = true;
		document.getElementsByClassName("mark-none")[1].disabled = true;
	},

	removeCollaborator: function(e){
		switch(this.typeModal){
			case '0':
				var that = this;
				var markedElements = e.currentTarget.parentElement.nextElementSibling.getElementsByClassName("selected");
				var listElements = e.currentTarget.parentElement.nextElementSibling.getElementsByClassName("markUser");
				if(markedElements.length == listElements.length){
					this.remCollaborators = e;
					window.spinnerDialog.show();
					toastr.options.timeOut = "0";
					toastr.options.extendedTimeOut = "0";
					toastr.options.closeButton = false;
					toastr.options.tapToDismiss = false;
					var txt = '<span>'+ arrlang[lang]["RemAllCollaboratorsSuperCat"] +'</span><br><button class="btntoastr btnaccept">'+ arrlang[lang]["ToastrAccept"] +'</button><button class="btntoastr btncancel">'+ arrlang[lang]["ToastrCancel"] +'</button>';
					this.toastrButtons(txt, 'warning');
					$('.btnaccept').one("click", function(e){
						that.acceptButtonRemCollaboratorSuperCat(that.remCollaborators);
					});
					$('.btncancel').one("click", function(){
						that.cancelButtonRemCollaboratorSuperCat();
					});
				}
				else{
					this.removeCollaboratorSuperCat(e);
				}
			break;
			case '1':
				this.removeCollaboratorSubCat(e);
			break;
			case '2':
				this.removeCollaboratorNewSuperCat(e);
			break;
			case '3':
				this.removeCollaboratorNewSubCat(e);
			break;
		}
	},

	acceptButtonRemCollaboratorSuperCat: function(e){
		toastr.options.timeOut = "5000";
		toastr.options.extendedTimeOut = "1000";
		toastr.options.closeButton = true;
		toastr.options.tapToDismiss = true;
		window.spinnerDialog.hide();
		toastr.remove();
		this.removeCollaboratorSuperCat(e);
	},

	cancelButtonRemCollaboratorSuperCat: function(){
		toastr.options.timeOut = "5000";
		toastr.options.extendedTimeOut = "1000";
		toastr.options.closeButton = true;
		toastr.options.tapToDismiss = true;
		window.spinnerDialog.hide();
		toastr.remove();
	},

	removeCollaboratorSuperCat: function(e){
		//quitar de la base de datos
		var that = this;
		var listElements = e.currentTarget.parentElement.nextElementSibling.getElementsByClassName("selected");
		var listIds = [];
		for(var i = 0; i < listElements.length; ++i){
			listIds.push(listElements[i].getAttribute("value"));
		}
		Parse.Cloud.run("removeCollaboratorSuperCategory", { 'categoryId': that.superCategoryId, 'listUsers': listIds }).then(function(result) {
			toastr.success("Colaboradores removidos satisfactoriamente","Operación realizada");
			var superCategoryPromise = getReportSuperCategoryService().fetch({
				all: true,
				cache: false,
				rules: {
					equals: [{
						key: 'objectId',
						val: that.superCategoryId
					}]
				}
			}).then(superCategory => {
				for (var i = 0; i < that.superCategories.length; i++) {
					if(that.superCategories[i].id == superCategory.models[0].id){
						that.superCategories[i] = superCategory.models[0];
					}
				}
				var queryPromise = superCategory.models[0].attributes.collaborators.query().find();
				Parse.Promise.when(queryPromise).then((collaborators) => {
					Parse.Cloud.run("getallusers", that.params).then(allusers => {
						var notCollaborators = allusers;
						for(var i = 0; i < collaborators.length; ++i){
							for(var j = 0; j < notCollaborators.length; ++j){
								if(collaborators[i].id == notCollaborators[j].id){
									notCollaborators.splice(j, 1);
								}
							}
						}
						$("#notcollaborators").html('');
						$("#collaborators").html('');
						that.setcollabs(notCollaborators, collaborators);
					},
					(error) => {
						console.log(error);
						switch(error.code){
							case 100:
								toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
							break;
						}
					});
				},
				(error) => {
					console.log(error);
					switch(error.code){
						case 100:
							toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
						break;
					}
				});
			},
			(error) => {
				console.log(error);
				switch(error.code){
					case 100:
						toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
					break;
				}
			});
		},
		(error) => {
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		});
		document.getElementsByClassName("add-collaborator")[0].disabled = true;
		document.getElementsByClassName("rm-collaborator")[0].disabled = true;
		document.getElementsByClassName("mark-all")[0].disabled = false;
		document.getElementsByClassName("mark-none")[0].disabled = true;
		document.getElementsByClassName("mark-none")[1].disabled = true;
	},

	removeCollaboratorSubCat: function(e){
		//quitar de la base de datos
		var that = this;
		var listElements = e.currentTarget.parentElement.nextElementSibling.getElementsByClassName("selected");
		var listIds = [];
		for(var i = 0; i < listElements.length; ++i){
			listIds.push(listElements[i].getAttribute("value"));
		}
		Parse.Cloud.run("removeCollaboratorSubCategory", { 'subCategoryId': that.subCategoryId, 'listUsers': listIds }).then(function(result) {
			toastr.success("Colaboradores removidos satisfactoriamente","Operación realizada");
			var subCategoryPromise = getReportSubCategoryService().fetch({
				all: true,
				cache: false,
				rules: {
					equals: [{
						key: 'objectId',
						val: that.subCategoryId
					}]
				}
			}).then(subCategory => {
				for (var i = 0; i < that.subCategories.length; i++) {
					if(that.subCategories[i].id == subCategory.models[0].id){
						that.subCategories[i] = subCategory.models[0];
					}
				}
				var queryPromise = subCategory.models[0].attributes.collaborators.query().find();
				Parse.Promise.when(queryPromise).then((collaborators) => {
					Parse.Cloud.run("getallusers", that.params).then(allusers => {
						var notCollaborators = allusers;
						for(var i = 0; i < collaborators.length; ++i){
							for(var j = 0; j < notCollaborators.length; ++j){
								if(collaborators[i].id == notCollaborators[j].id){
									notCollaborators.splice(j, 1);
								}
							}
						}
						$("#notcollaborators").html('');
						$("#collaborators").html('');
						that.setcollabs(notCollaborators, collaborators);
					},
					(error) => {
						console.log(error);
						switch(error.code){
							case 100:
								toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
							break;
						}
					});
				},
				(error) => {
					console.log(error);
					switch(error.code){
						case 100:
							toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
						break;
					}
				});
			},
			(error) => {
				console.log(error);
				switch(error.code){
					case 100:
						toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
					break;
				}
			});
		},
		(error) => {
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		});
		document.getElementsByClassName("add-collaborator")[0].disabled = true;
		document.getElementsByClassName("rm-collaborator")[0].disabled = true;
		document.getElementsByClassName("mark-all")[0].disabled = false;
		document.getElementsByClassName("mark-none")[0].disabled = true;
		document.getElementsByClassName("mark-none")[1].disabled = true;
	},

	removeCollaboratorNewSuperCat: function(e){
		//quitar de la base de datos
		var that = this;
		var listElements = e.currentTarget.parentElement.nextElementSibling.getElementsByClassName("selected");
		var listIds = [];
		for(var i = 0; i < listElements.length; ++i){
			listIds.push(listElements[i].getAttribute("value"));
		}
		var notCollaborators = this.newNotCollaborators;
		var collaborators = this.newCollaborators;
		for(var i = 0; i < listIds.length; ++i){
			for(var j = 0; j < collaborators.length; ++j){
				if(listIds[i] == collaborators[j].id){
					notCollaborators.push(collaborators[j]);
				}
			}
		}
		for(var i = 0; i < notCollaborators.length; ++i){
			for(var j = 0; j < collaborators.length; ++j){
				if(notCollaborators[i].id == collaborators[j].id){
					collaborators.splice(j, 1);
				}
			}
		}
		this.newNotCollaborators = notCollaborators;
		this.newCollaborators= collaborators;
		$("#notcollaborators").html('');
		$("#collaborators").html('');
		that.setcollabs(notCollaborators, collaborators);
		document.getElementsByClassName("add-collaborator")[0].disabled = true;
		document.getElementsByClassName("rm-collaborator")[0].disabled = true;
		document.getElementsByClassName("mark-all")[0].disabled = false;
		document.getElementsByClassName("mark-none")[0].disabled = true;
		document.getElementsByClassName("mark-none")[1].disabled = true;
	},

	removeCollaboratorNewSubCat: function(e){
		//quitar de la base de datos
		var that = this;
		var listElements = e.currentTarget.parentElement.nextElementSibling.getElementsByClassName("selected");
		var listIds = [];
		for(var i = 0; i < listElements.length; ++i){
			listIds.push(listElements[i].getAttribute("value"));
		}
		var notCollaborators = this.newNotCollaborators;
		var collaborators = this.newCollaborators;
		for(var i = 0; i < listIds.length; ++i){
			for(var j = 0; j < collaborators.length; ++j){
				if(listIds[i] == collaborators[j].id){
					notCollaborators.push(collaborators[j]);
				}
			}
		}
		for(var i = 0; i < notCollaborators.length; ++i){
			for(var j = 0; j < collaborators.length; ++j){
				if(notCollaborators[i].id == collaborators[j].id){
					collaborators.splice(j, 1);
				}
			}
		}
		this.newNotCollaborators = notCollaborators;
		this.newCollaborators= collaborators;
		$("#notcollaborators").html('');
		$("#collaborators").html('');
		that.setcollabs(notCollaborators, collaborators);
		document.getElementsByClassName("add-collaborator")[0].disabled = true;
		document.getElementsByClassName("rm-collaborator")[0].disabled = true;
		document.getElementsByClassName("mark-all")[0].disabled = false;
		document.getElementsByClassName("mark-none")[0].disabled = true;
		document.getElementsByClassName("mark-none")[1].disabled = true;
	},

	openlangmodal: function(subcat){
		getLocalizationService().getLanguages().then(function(query){
			var handlebarsTemplate = Handlebars.template(languages_template);
			if(subcat){
				$("#selectlanguagemodal").html(handlebarsTemplate({languages: query, btnid: 'setsubcattranslation', categ: false}));
			} else {
				$("#selectlanguagemodal").html(handlebarsTemplate({languages: query, btnid: 'setcattranslation', categ: true}));
			}
		},
		function(error){
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		});
	},

	languageRadioChange: function(e){
		var sectionbtn = $(e.currentTarget).data('sectionbtn');
		$(sectionbtn).prop('disabled', false);
		var categ = $(e.currentTarget).data('categ');
		var that = this;
		var value = e.currentTarget.value;
		getLocalizationService().getLanguageCatLang(value).then((result) => {
			that.catLangJson = JSON.parse(result.attributes.catlang);
			var entry = that.catLangJson[that.superCategoryId];
			if(categ){
				if(entry === undefined){
					$('#newnametranslate').val("");
					$('#newdescrtranslate').val("");
				} else {
					var name = entry["Name"];
					$('#newnametranslate').val(name ? name : "");
					var descr = entry["Description"];
					$('#newdescrtranslate').val(descr ? descr : "");
				}
			} else {
				if(entry === undefined || entry[that.subCategoryId] === undefined){
					$('#newnametranslate').val("");
				} else {
					var currentVal = entry[that.subCategoryId];
					$('#newnametranslate').val(currentVal);
				}
			}
		},
		(error) => {
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		});
	},

	languageSubcatEdit: function(){
		var newValue = $('#newnametranslate').val();
		var entry = this.catLangJson[this.superCategoryId];
		if(entry === undefined){ this.catLangJson[this.superCategoryId] = {}; }
		this.catLangJson[this.superCategoryId][this.subCategoryId] = newValue;
		var catLangString = JSON.stringify(this.catLangJson);
		var lang = $('input[name=languages]:checked').val();
		getLocalizationService().updateLanguageCatLang(lang, catLangString);
	},

	languageCatEdit: function(){
		var newName = $('#newnametranslate').val();
		var newDesc = $('#newdescrtranslate').val();
		var entry = this.catLangJson[this.superCategoryId];
		if(entry === undefined){ this.catLangJson[this.superCategoryId] = {}; }
		this.catLangJson[this.superCategoryId]["Name"] = newName;
		this.catLangJson[this.superCategoryId]["Description"] = newDesc;
		var catLangString = JSON.stringify(this.catLangJson);
		var lang = $('input[name=languages]:checked').val();
		getLocalizationService().updateLanguageCatLang(lang, catLangString);
	},
});
export default AdminCategoriesView;
